export default __webpack_public_path__ + "static/media/gernaut.1c23b78f.png";